<template>
  <v-container>
    <v-dialog v-model="dialogProduct" scrollable   persistent :overlay="false" max-width="500px" transition="dialog-transition">
      <v-card>

          <v-card-title primary-title>
            {{ dialogProductTitle }} <v-spacer></v-spacer> <v-btn color="black" icon @click="closeDialogProduct"><v-icon>mdi-close</v-icon></v-btn>
          </v-card-title>
          <v-card-text class="mt-3">
            <v-row dense>
              <v-col v-if="typeof(product.image1) == 'string'" cols="4">
                <v-img  :src="`${$store.state.apiUrl}static/images/thumb/${product.image1}`" height="60">
                <v-icon color="white" class="align-right" @click="product.image1 = null ">mdi-close-circle</v-icon>
                </v-img>
              </v-col>
              <v-col v-else cols="12">
                <v-file-input outlined hide-details dense ref="img1" prepend-icon="mdi-image" placeholder="Product image 1" v-model="product.image1"></v-file-input>
              </v-col>

              <v-col v-if="typeof(product.image2) == 'string'" cols="4"><v-img :src="`${$store.state.apiUrl}static/images/thumb/${product.image2}`" height="60" v-if="typeof(product.image2) == 'string'">
                <v-icon color="white" class="align-right" @click="product.image2 = null ">mdi-close-circle</v-icon>
              </v-img></v-col>
              <v-col v-else cols="12"><v-file-input outlined hide-details dense ref="img1" prepend-icon="mdi-image" placeholder="Product image 2" v-model="product.image2"></v-file-input></v-col>

              <v-col v-if="typeof(product.image3) == 'string'" cols="4"><v-img :src="`${$store.state.apiUrl}static/images/thumb/${product.image3}`" height="60" v-if="typeof(product.image3) == 'string'">
                <v-icon color="white" class="align-right" @click="product.image3 = null ">mdi-close-circle</v-icon>
              </v-img></v-col>
              <v-col v-else cols="12"><v-file-input outlined dense ref="img1" prepend-icon="mdi-image" placeholder="Product image 3" v-model="product.image3"></v-file-input></v-col>
            </v-row>

            <v-text-field label="Name" v-model="product.name"></v-text-field>
            <v-text-field label="Price" v-model.number="product.price"></v-text-field>
            <v-textarea label="Description" rows="3" v-model="product.description"></v-textarea>
          </v-card-text>
          <v-card-actions>
            <v-btn block color="primary" @click="saveProduct">{{ dialogProductBtn }}</v-btn>
          </v-card-actions>

      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  export default {
    data(){
      return {
        dialogProduct: false,
        product: { description: '' },
      }
    },

    computed:{
      dialogProductTitle(){
        return (!this.product.id)  ? 'Add product' : 'Edit product';
      },
      dialogProductBtn(){
        return (!this.product.id)  ? 'Save' : 'Update';
      },
    },

    methods: {
      getProducts(){
        this.axios.get('products').then( (res) => {
          this.$store.commit('mutate', { prop: 'products', data: res.data })
        }).catch( (err) => {
          console.log(err)
        })
      },

      closeDialogProduct(){
        this.$emit('closeDialog', this.product)
      },

      saveProduct(){
        if(!this.product.name || !this.product.price){
          this.$store.commit('mutate', { prop: 'snackbar', data: { text: "Incomplete date", value:true } })
        }
        let fd = new FormData()
        for ( var key in this.product ) {
          fd.append(key, this.product[key]);
        }

        if(!this.product.id){
          this.axios.post('products', fd ).then( () => {
            this.closeDialogProduct();
            this.getProducts();
            this.$store.commit('mutate', { prop: 'snackbar', data: { text: "Success", value:true } })
          }).catch( (err) => {
            this.$store.commit('mutate', { prop: 'snackbar', data: { text: err.response.data.msg, value:true } })
          })
        } else {
          this.axios.put('products/' + this.product.id , fd ).then( () => {
            this.closeDialogProduct();
            this.getProducts();
            this.$store.commit('mutate', { prop: 'snackbar', data: { text: "Success", value:true } })
          }).catch( (err) => {
            this.$store.commit('mutate', { prop: 'snackbar', data: { text: err.response.data.msg, value:true } })
          })
        }
      },
    }

  }
</script>